<template>
  <div>
    <div id="main-content" :key="entry.text" v-for="entry in texts">
      <TextContainer
        v-if="entry.text.length < 700"
        :src="entry.imgPath"
        v-bind:id="entry.id"
        v-bind:content="entry.text"
        v-bind:orientation="entry.orientation"
        v-bind:title="entry.title"
      />

      <BigTextContainer
        v-else
        :src="entry.imgPath"
        v-bind:id="entry.id"
        v-bind:content="entry.text"
        v-bind:orientation="entry.orientation"
        v-bind:title="entry.title"
      />
    </div>
  </div>
</template>

<script>
import TextContainer from "../components/TextContainer";
import BigTextContainer from "../components/BigTextContainer";
export default {
  name: "Projects",
  components: {
    BigTextContainer,
    TextContainer
  },
  data() {
    return {
      page: "projects",
      texts: []
    };
  },
  created() {
    this.$api
      .get(`/maintext/page/${this.page}`)
      .then(response => (this.texts = response.data));
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Projects.vue